import React from "react";
import PublicationsAndPatentsView from "./view";

const PublicationsAndPatentsPage = () => {
  return <PublicationsAndPatentsView />;
};

export default PublicationsAndPatentsPage;